import { useState } from 'react';
import usePhotos from '../hooks/usePhotos.js';
import LoadingSpinner from '../components/common/LoadingSpinner.jsx';
import ErrorMessage from '../components/common/ErrorMessage.jsx';
import SuccessMessage from '../components/common/SuccessMessage.jsx';

const UploadPage = () => {
    const { loading, error, uploadImage, image, updateIcons } = usePhotos();

    const [name, setName] = useState('');
    const [file, setFile] = useState(null);
    const [iconSuccess, setIconSuccess] = useState('');

    const handleFileSelection = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpdateIcons = async () => {
        setIconSuccess('');
        await updateIcons();
        setIconSuccess('Icons updated successfully for all users!');
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
            <h4 style={{ marginBottom: '2em' }}>Upload New Signature Logo</h4>
            <p>Enter a label for this signature logo version</p>
            <input
                placeholder="Logo version"
                className="create-input"
                onChange={(e) => setName(e.target.value)}
            />
            <div className="input-group mb-3" style={{ width: '50%' }}>
                <input
                    type="file"
                    className="form-control"
                    id="inputGroupFile01"
                    onChange={handleFileSelection}
                    accept="image/png, image/gif, image/jpeg"
                />
            </div>
            <p>Must be jpeg, jpg, or png</p>
            <button
                className="btn btn-primary btn-block"
                onClick={() => uploadImage(name, file)}>
                Upload Logo
            </button>
            <br />
            <button
                className="btn btn-warning btn-block"
                onClick={handleUpdateIcons}
                style={{ marginTop: '10px' }}>
                Update Icons (Refresh Gmail Signatures)
            </button>

            <br />
            {loading && <LoadingSpinner />}
            {error && <ErrorMessage message={error.message} />}
            {image && <SuccessMessage message="Logo successfully updated!" />}
            {iconSuccess && <SuccessMessage message={iconSuccess} />}
        </div>
    );
};

export default UploadPage;
